/* eslint-disable */
import React, { useEffect, useState } from "react";
import BossDialog from "../../components/BossDialog";
import * as API from "../../framework/API/api"
import { ENTITYNAME, LOGEVENT, MODULE, OFFER_TYPE, TOAST_TYPES } from "../../framework/constant/constant";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { EditPageHeader } from "../../components/EditPageHeader";
import { useTranslation } from "../../locale/useTranslation";
import { utility } from "../../framework/utility/utilityProvider";
import ToastNotification from "../../components/ToastNotification";

export const OfferEditForm = (props) => {

  const lang = useTranslation();
  const nowLocal = utility.nowToDateTimeLocal();
  // when using this componetn we pass hardcoded offer type because when calling this compoennt we know if we are creating offer from node level or asset level
  const hardCodedOfferType = props.hardCodedOfferType ?? null;

  const blankDataItem = {
    ...props?.item,
    SID: props?.item?.SID ?? 0,
    Title: props?.item?.copy ? 'copy of ' + props?.item?.Title : props?.item?.Title ?? '',
    Description: props?.item?.Description ?? '',
    TranslatedDescription: props?.item?.TranslatedDescription ?? "",
    DisplayTitle: props?.item?.DisplayTitle,
    TranslatedDisplayTitle: props?.item?.TranslatedDisplayTitle ?? "",
    StartDateTime: props?.item?._id ? props?.item?.StartDateTime ? utility.msToDateTimeLocal(props?.item?.StartDateTime) : null : nowLocal,
    EndDateTime: props?.item?._id ? props?.item?.EndDateTime ? utility.msToDateTimeLocal(props?.item?.EndDateTime) : null : utility.addDaysToDateTimeLocal(nowLocal, 2),
    PriceCode: props?.item?.PriceCode ?? {},
    OfferType: { _id: props?.item?.OfferType ?? hardCodedOfferType, Description: utility.getKeyByValue(OFFER_TYPE, props?.item?.OfferType ?? hardCodedOfferType) },
    Runs: props?.item?.Runs ?? '',
    IsPayPerTime: props?.item?.IsPayPerTime ?? true,
    Archive: props?.item?.Archive ?? false,
    ExternalReference: props?.item?.ExternalReference ?? ""
  }

  const [dataItem, setDataItem] = useState(blankDataItem);
  const [pricecode, setPriceCode] = useState([]);
  const [showPriceDetail, setShowPriceDetail] = useState(false);

  const handleMouseEnter = () => setShowPriceDetail(true);
  const handleMouseLeave = () => setShowPriceDetail(false);

  useEffect(() => {
    loadCombo();
  }, [])

  const loadCombo = async () => {
    let priceCodeRes = await API.getDataLookup(ENTITYNAME.PRICECODE, { sort: { Description: 1 } });
    setPriceCode(priceCodeRes.data);
  }

  const onChangeForm = (e) => {
    if (e.target.name == "Archive") {
      setDataItem({ ...dataItem, Archive: !dataItem.Archive });
    } else if (e.target.name == "IsPayPerTime") {
      setDataItem({ ...dataItem, IsPayPerTime: !dataItem.IsPayPerTime });
    } else {
      setDataItem({ ...dataItem, [e.target.name]: e.target.value });
    }
  }

  const isValid = () => {

    if (dataItem.Title == undefined || dataItem.Title.trim().length == 0 || dataItem.Title == "") {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: `${lang.please_enter_title_error_message}` });
      return false;
    }
    if (dataItem.DisplayTitle == undefined || dataItem.DisplayTitle.trim().length == 0 || dataItem.DisplayTitle == "") {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: `${lang.please_enter_display_title_error_message}` });
      return false;
    }
    if (dataItem.Description == undefined || dataItem.Description.trim().length == 0 || dataItem.Description == "") {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: `${lang.please_enter_description_error_message}` });
      return false;
    }

    return true;
  }

  const handleSubmit = async (e) => {

    if (!isValid()) return;

    const saveData = {
      _id: dataItem?._id,
      SID: dataItem?.SID ?? 0,
      Title: dataItem.Title,
      Description: dataItem.Description,
      TranslatedDescription: dataItem.TranslatedDescription,
      DisplayTitle: dataItem.DisplayTitle,
      TranslatedDisplayTitle: dataItem.TranslatedDisplayTitle,
      StartDateTime: dataItem.StartDateTime ? utility.convertStringDateTimeToMilliseconds(dataItem.StartDateTime) : null,
      EndDateTime: dataItem.EndDateTime ? utility.convertStringDateTimeToMilliseconds(dataItem.EndDateTime) : null,
      PriceCode: dataItem?.PriceCode && Object.keys(dataItem?.PriceCode).length > 0 ? {
        _id: dataItem?.PriceCode?._id,
        SID: dataItem?.PriceCode?.SID,
        CSID: dataItem?.PriceCode?.CSID,
        Description: dataItem?.PriceCode?.Description,
        Code: dataItem?.PriceCode?.Code,
        Price: dataItem?.PriceCode?.Price,
        Currency: dataItem?.PriceCode?.Currency,
        Days: dataItem?.PriceCode?.Days,
        Duration: dataItem?.PriceCode?.Duration
      } : {},
      OfferType: dataItem.OfferType?._id,
      Runs: dataItem.Runs,
      IsPayPerTime: dataItem.OfferType?._id == OFFER_TYPE.subscription ? dataItem.IsPayPerTime : false,
      Archive: dataItem.Archive ?? false,
      ExternalReference: dataItem.ExternalReference ?? "",
      checkDuplicate: true,
      query: [["Title", "=", dataItem.Title]],
    }
    console.log(saveData);

    let res = await API.saveData(ENTITYNAME.OFFER, saveData);
    if (res.success) {
      let logData = { event: res.message == "updated" ? LOGEVENT.UPDATE : LOGEVENT.INSERT, module: MODULE.OFFER, data: res.data, message: res.message };
      API.SaveLogs(logData);
      utility.deleteLocalStorageItem(ENTITYNAME.OFFER);
      if (props.handleAttachOffers && res.data) {
        props.handleAttachOffers([res.data]);
      }
      props.cancelEdit();
      props.refresh && props.refresh();
    }
    else {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
    }

  }

  return (
    <BossDialog
      title={dataItem?._id ? lang.edit_offer_dialog_title : lang.create_offer_dialog_title}
      onClose={props.cancelEdit}
      width="770px"
    >
      <div className="row align-items-center">
        <div className="col" >
          <EditPageHeader title={""} onSubmit={handleSubmit} onCancel={props.cancelEdit} showTitle={false} />
        </div>
        {props.item?._id && (
          <div className="col-auto d-flex align-items-center">
            <label className="mb-0 mr-2">{lang.offer_csid_label}:</label>
            <div className="d-flex align-items-center px-2" disabled style={{ width: "110px", height: "30px", border: "1px solid rgb(197 200 201 / 88%)", borderRadius: "4px", backgroundColor: "#eaeef1", fontSize: "13px" }} >{props.item?.CSID}</div>
          </div>
        )}
      </div>
      <div className="row mt-2">
        <div className="col-12">
          <div className="row form-group">
            <div className="col-6">
              <label>{lang.title_label} *</label>
              <input
                name={"Title"}
                type="text"
                className="form-control form-control-sm"
                onChange={onChangeForm}
                value={dataItem.Title}
              />
            </div>
            <div className="col-6">
              <label>{lang.price_code_label}</label>

              <div
                className="position-relative price-hover-wrapper"
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
              >
                <DropDownList
                  style={{ backgroundColor: "white" }}
                  data={pricecode}
                  name="PriceCode"
                  textField="Description"
                  dataItemKey="_id"
                  value={dataItem.PriceCode}
                  onChange={onChangeForm}
                />

                {showPriceDetail && dataItem.PriceCode?._id && (
                  <div className="price-hover-card left">
                    <div><b>Description:</b> {dataItem?.PriceCode?.Description}</div>
                    <div><b>Currency:</b> {dataItem.PriceCode?.Currency?.Description}</div>
                    <div><b>Code:</b> {dataItem?.PriceCode?.Code}</div>
                    <div><b>Price:</b> {dataItem?.PriceCode?.Price}</div>
                    <div><b>Days:</b> {dataItem?.PriceCode?.Days}</div>
                    <div><b>Duration:</b> {dataItem?.PriceCode?.Duration ? utility.convertMilisecondsToStringWithFrames(dataItem?.PriceCode?.Duration) : "00:00:00:00"}</div>
                  </div>
                )}
              </div>
            </div>

          </div>
          <div className="row form-group">
            <div className="col-6">
              <label>{lang.display_title_label} *</label>
              <input
                name={"DisplayTitle"}
                type="text"
                className="form-control form-control-sm"
                onChange={onChangeForm}
                value={dataItem.DisplayTitle}
              />
            </div>
            <div className="col-6">
              <label>{lang.description_label} *</label>
              <input
                name={"Description"}
                type="text"
                className="form-control form-control-sm"
                onChange={onChangeForm}
                value={dataItem.Description}
              />
            </div>
          </div>
          <div className="row form-group">
            <div className="col-6">
              <label>{lang.start_date_time_label} *</label>
              <input
                name="StartDateTime"
                type="datetime-local"
                className="form-control form-control-sm"
                value={dataItem?.StartDateTime}
                onChange={onChangeForm}
              />
            </div>
            <div className="col-6">
              <label>{lang.end_date_time_label} *</label>
              <input
                name="EndDateTime"
                type="datetime-local"
                className="form-control form-control-sm"
                value={dataItem?.EndDateTime}
                onChange={onChangeForm}
              />
            </div>
          </div>
          <div className="row form-group">
            <div className="col-6">
              <label>{lang.translated_display_title_label}</label>
              <input
                name={"TranslatedDisplayTitle"}
                type="text"
                className="form-control form-control-sm"
                onChange={onChangeForm}
                value={dataItem.TranslatedDisplayTitle}
              />
            </div>
            <div className="col-6">
              <label>{lang.translated_Description_label}</label>
              <input
                name={"TranslatedDescription"}
                type="text"
                className="form-control form-control-sm"
                onChange={onChangeForm}
                value={dataItem.TranslatedDescription}
              />
            </div>
          </div>
          <div className="row form-group">
            <div className="col-6">
              <label htmlFor="">{lang.runs_label}</label>
              <input type="number" className="form-control form-control-sm" name="Runs" value={dataItem.Runs} onChange={(e) => onChangeForm(e)} min={0} />
            </div>
            <div className="col-6">
              <label>{lang.external_reference_label}</label>
              <input
                name={"ExternalReference"}
                type="text"
                className="form-control form-control-sm"
                onChange={onChangeForm}
                value={dataItem.ExternalReference}
              />
            </div>
          </div>
          <div className="row form-group">
            <div className="col-6" >
              <label>{lang.offer_type_label}</label>
              <DropDownList
                style={{ backgroundColor: "white" }}
                data={Object.keys(OFFER_TYPE)
                  .filter((key) =>
                    hardCodedOfferType
                      ? OFFER_TYPE[key] === hardCodedOfferType
                      : true
                  )
                  .map((key) => ({
                    _id: OFFER_TYPE[key],
                    Description: key
                  }))
                }
                name="OfferType"
                textField="Description"
                dataItemKey="_id"
                value={dataItem.OfferType}
                onChange={onChangeForm}
              />
            </div>
            {dataItem.OfferType._id === OFFER_TYPE.subscription && <div className="col-3" style={{ marginTop: "22px" }}>
              <input type={"checkbox"} name={"IsPayPerTime"}
                onChange={(e) => onChangeForm(e)}
                value={dataItem.IsPayPerTime}
                checked={dataItem.IsPayPerTime} />
              <label className="ml-1">{lang.pay_per_time_label}</label>
            </div>}
            <div className="col-3" style={{ marginTop: "22px" }}>
              <input type={"checkbox"} name={"Archive"}
                onChange={(e) => onChangeForm(e)}
                value={dataItem.Archive}
                checked={dataItem.Archive} />
              <label className="ml-1">{lang.archive}</label>
            </div>
          </div>
        </div>
      </div>
    </BossDialog>)
};